export default {"src":"/_next/static/media/eth.8e5a63b6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};